export const DOCUMENT_STATUS_ACTIVE = 'ACTIVE' as const;
export const DOCUMENT_STATUS_DELETED = 'DELETED' as const;
export const DOCUMENT_STATUS_ARCHIVED = 'ARCHIVED' as const;

export const AllDocumentStatus = [DOCUMENT_STATUS_ACTIVE, DOCUMENT_STATUS_DELETED, DOCUMENT_STATUS_ARCHIVED];
export type DocumentStatus = (typeof AllDocumentStatus)[number];
